<template>
    <div class="menu">
        <div class="row center-xs middle-xs">
            <!--<div class="col-sm-1 col-md-2 col-lg-3"></div>-->
            <div class="col-sm-2 col-lg-1 button" v-on:click="onclickmenu('about')"><p class="label">Sobre</p></div>
            <div class="col-sm-2 col-lg-1 button">
                <div class="dropdown">
                    <div class="button"
                         v-on:click="onclickmenu('services', 'services-menu')"
                         v-on:mouseover="onmouseovermenu('services-menu')"
                         v-on:mouseleave="onmouseleavemenu('services-menu')">
                        <p class="label">Serviços</p>
                    </div>
                    <div id="services-menu" class="dropdown-content" v-if="services"
                         v-on:mouseover="onmouseovermenu('services-menu')"
                         v-on:mouseleave="onmouseleavemenu('services-menu')">
                        <div v-on:click="onEntrySelection('service', service, 'services-menu')" v-for="service in services.items" :key="service.fields.title">
                            <p>{{service.fields.title}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2 col-lg-1 button" v-on:click="onclickmenu('portfolio')"><p class="label">Portfólio</p></div>
            <!--<div class="col-sm-2 col-md-1 col-lg-1 button" v-on:click="onclickmenu('guidedtours')"><p>Visitas Guiadas</p></div>-->
            <div class="col-sm-2 col-lg-1 button">
                <div class="dropdown">
                    <div class="button"
                         v-on:click="onclickmenu('guided-tours')"
                         v-on:mouseover="onmouseovermenu('guided-tours-menu')"
                         v-on:mouseleave="onmouseleavemenu('guided-tours-menu')">
                        <p class="label">Visitas Guiadas</p>
                    </div>
                    <div id="guided-tours-menu" class="dropdown-content" v-if="guidedTours"
                         v-on:mouseover="onmouseovermenu('guided-tours-menu')"
                         v-on:mouseleave="onmouseleavemenu('guided-tours-menu')">
                        <div v-on:click="onEntrySelection('guided-tours', guidedTour, 'guided-tours-menu')" v-for="guidedTour in guidedTours.items" :key="guidedTour.fields.title">
                            <p>{{guidedTour.fields.title}}</p>
                        </div>
                        <div v-on:click="onListSelection('guided-tours')">
                            <p>Mais Visitas</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2 col-lg-1 button">
                <div class="dropdown">
                    <div class="button"
                         v-on:click="onclickmenu('publications', 'publications-menu')"
                         v-on:mouseover="onmouseovermenu('publications-menu')"
                         v-on:mouseleave="onmouseleavemenu('publications-menu')">
                        <p class="label">Publicações</p>
                    </div>
                    <div id="publications-menu" class="dropdown-content" v-if="publications"
                         v-on:mouseover="onmouseovermenu('publications-menu')"
                         v-on:mouseleave="onmouseleavemenu('publications-menu')">
                        <div v-on:click="onEntrySelection('publication', publication, 'publications-menu')" v-for="publication in publications.items" :key="publication.fields.title">
                            <p>{{publication.fields.title}}</p>
                        </div>
                        <div v-on:click="onListSelection('publication')">
                            <p>Mais Publicações</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2 col-lg-1 button" v-on:click="onclickmenu('contacts')"><p class="label">Contactos</p></div>
            <!--<div class="col-sm-1 col-md-2 col-lg-3"></div>-->
        </div>
    </div>
</template>

<script>
    import {getGuidedTours, getPublications, getServices} from "../services/data.service";

    export default {
        name: "MenuDesktop",
        data() {
            return {
                services: null,
                publications: null,
                guidedTours: null
            }
        },
        methods: {
            onclickmenu(tab, menu) {
                this.$emit('menu-selection', tab);

                if (menu) {
                    this.closeMenu(menu);
                }
            },
            onmouseovermenu(menu) {
                const open = document.querySelector("#".concat(menu));
                if (open)
                    open.setAttribute("style", "visibility: visible;");
            },
            onmouseleavemenu(menu) {
                this.closeMenu(menu);
            },
            onEntrySelection(type, entry, menu) {
                this.closeMenu(menu);
                this.$emit('entry-selection', {type: type, id: entry.sys.id});
            },
            onListSelection(selection) {
                this.$emit('list-selection', selection);
            },
            closeMenu(menu) {
                const close = document.querySelector("#".concat(menu));
                if (close)
                    close.setAttribute("style", "visibility: hidden;");
            }
        },
        mounted() {
            getServices().subscribe(services => {
                this.services = services;
            });

            getGuidedTours().subscribe(guidedTours => {
                this.guidedTours = guidedTours;
            });

            getPublications().subscribe(publications => {
                this.publications = publications;
            });
        }
    }
</script>

<style lang="scss">
    @import "../assets/styles/global";

    .menu {
        width: 100%;
        height: 2.3em;
        background-color: $primary;
        z-index: 99;
        border-bottom-color: white;
        border-bottom-style: solid;
        border-bottom-width: thin;

        .row {
            height: 100%;
            margin-left: 0;
            margin-right: 0;

            .button {
                color: $bgcolor;
                background-color: $primary;
                height: 100%;
                position: relative;

                p {
                    cursor: default;
                    font-weight: 500;
                    font-size: 0.65em;
                    letter-spacing: 0.15em;
                    text-transform: uppercase;
                }

                p.label {
                    font-weight: 600;
                    font-size: 0.7em;

                    margin: 0;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                    width: 100%;

                    margin-block-start: 0em;
                    margin-block-end: 0em;
                }

                &:hover {
                    color: $primary;
                    background-color: $bgcolor;
                };
            }
        }
    }

    .dropdown {
        position: relative;
        display: flex;
        height: 100%;
        margin-left: -0.5em;
        margin-right: -0.5em;
        z-index: 1;

        .button {
            width: 100%;
            height: 100%;
            p {
                /*margin-block-end: 0.8em !important;
                margin-block-start: 0.8em !important;*/
                cursor: default;
                font-weight: 500;
                font-size: 0.65em;
                text-transform: uppercase;
            }
        }
        .dropdown-content {
            position: absolute;
            visibility: hidden;
            z-index: 9999;
            margin-top: 2.3em;
            width: 16.2vw;

            @media screen and (min-width: 1020px) {
                width: 8.3vw;
            }

            div {
                height: 2.5em;
                background-color: $bgcolor-grey-transparent;
                display: inline-block;
                width: 90%;
                border-bottom-width: 0.01em;
                border-bottom-color: $bgcolor;
                border-bottom-style: solid;
                padding-left: 5%;
                padding-right: 5%;

                p {
                    font-size: 0.65em;
                    text-transform: uppercase;
                    color: $primary;
                    font-weight: 600;
                    letter-spacing: 0.12em;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }

                &:hover {
                    background-color: $primary-transparent;
                    border-bottom-color: $primary-transparent;
                    p {
                        color: $bgcolor;
                        font-weight: 500;
                    }
                };
            }
        }
    }
</style>
